import React, { useState } from "react";
import { FormProvider, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNotification } from "../../../Notification/Notification";
import { useNavigate, useParams } from "react-router-dom";
import ComInput from "../../../Components/ComInput/ComInput";
import ComTextArea from "../../../Components/ComInput/ComTextArea";
import ComSelect from "../../../Components/ComInput/ComSelect";
import ComButton from "../../../Components/ComButton/ComButton";
import * as yup from "yup";
import { postData } from "../../../api/api";

export default function EvaluationForm() {
  const navigate = useNavigate();
  const { notificationApi } = useNotification();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);

  const YupEvaluationForm = yup.object({
    suggestion: yup.string().required("Please provide suggestions"),
    yourExperience: yup.string().required("Please describe your experience"),
    foodRating: yup.number().required("Food rating is required").min(1).max(5),
    roomRating: yup.number().required("Room rating is required").min(1).max(5),
    monkRating: yup.number().required("Monk rating is required").min(1).max(5),
    retreatRating: yup
      .number()
      .required("Retreat rating is required")
      .min(1)
      .max(5),
  });

  const methods = useForm({
    resolver: yupResolver(YupEvaluationForm),
  });

  const {
    handleSubmit,
    register,
    setValue,
    formState: { errors },
    control,
  } = methods;

  const onSubmit = async (data) => {
    setDisabled(true);
    // Ensure ratings are numbers
    const formData = {
      retreatId: id,
      retreatRating: Number(data.retreatRating),
      monkRating: Number(data.monkRating),
      roomRating: Number(data.roomRating),
      foodRating: Number(data.foodRating),
      suggestion: data.suggestion, // Ensure this is the correct field name
      yourExperience: data.yourExperience,
    };
    console.log("Form submitted:", formData);
    try {
      postData("/Feedback", formData,{
              "Content-Type": "multipart/form-data",
            })
        .then((e) => {
          console.log(e);
          setDisabled(false);
          notificationApi("success", "Evaluation submitted successfully", "");
        })
        .catch((error) => {
          setDisabled(false);
          console.log(error);
        });
    } catch (error) {
      console.error(error);
      notificationApi("error", "Submission failed", "");
    } finally {
      setDisabled(false);
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold text-gray-800 mb-4">
        Evaluation Form
      </h2>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)}>
          {/* Retreat Rating */}
          <div className="mb-6">
            <ComSelect
              size={"large"}
              style={{ width: "100%" }}
              label="Retreat Rating"
              placeholder="Select retreat rating"
              options={[
                { value: 1, label: "1" },
                { value: 2, label: "2" },
                { value: 3, label: "3" },
                { value: 4, label: "4" },
                { value: 5, label: "5" },
              ]}
              onChangeValue={(name, value) => {
                setValue(name, value);
              }}
              {...register("retreatRating")}
              required
            />
          </div>

          {/* Monk Rating */}
          <div className="mb-6">
            <ComSelect
              size={"large"}
              style={{ width: "100%" }}
              label="Monk Rating"
              placeholder="Select monk rating"
              options={[
                { value: 1, label: "1" },
                { value: 2, label: "2" },
                { value: 3, label: "3" },
                { value: 4, label: "4" },
                { value: 5, label: "5" },
              ]}
              onChangeValue={(name, value) => {
                setValue(name, value);
              }}
              {...register("monkRating")}
              required
            />
          </div>

          {/* Room Rating */}
          <div className="mb-6">
            <ComSelect
              size={"large"}
              style={{ width: "100%" }}
              label="Room Rating"
              placeholder="Select room rating"
              options={[
                { value: 1, label: "1" },
                { value: 2, label: "2" },
                { value: 3, label: "3" },
                { value: 4, label: "4" },
                { value: 5, label: "5" },
              ]}
              onChangeValue={(name, value) => {
                setValue(name, value);
              }}
              {...register("roomRating")}
              required
            />
          </div>

          {/* Food Rating */}
          <div className="mb-6">
            <ComSelect
              size={"large"}
              style={{ width: "100%" }}
              label="Food Rating"
              placeholder="Select food rating"
              options={[
                { value: 1, label: "1" },
                { value: 2, label: "2" },
                { value: 3, label: "3" },
                { value: 4, label: "4" },
                { value: 5, label: "5" },
              ]}
              onChangeValue={(name, value) => {
                setValue(name, value);
              }}
              {...register("foodRating")}
              required
            />
          </div>

          {/* Your Experience */}
          <div className="space-y-4 mb-6">
            <ComTextArea
              label="Your Experience"
              placeholder="Describe your experience"
              {...register("yourExperience")}
              required
            />
          </div>

          {/* Suggestions */}
          <div className="mb-6">
            <ComTextArea
              label="Suggestion"
              placeholder="Provide any suggestions"
              {...register("suggestion")}
              required
            />
          </div>

          {/* Submit Button */}
          <div className="flex justify-end">
            <ComButton
              htmlType="submit"
              disabled={disabled}
              className={`px-6 py-2 bg-[#ffd966] hover:bg-[#ffd033] rounded transition-colors duration-200 ${
                disabled ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              {disabled ? "Submitting..." : "Submit Evaluation"}
            </ComButton>
          </div>
        </form>
      </FormProvider>
    </div>
  );
}
